import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { AutoPaySvgGuestComponent } from '../../../modules/mapfre-design-library/src/lib/svg/autopay-guest-svg/autopay-svg-guest.component';
import { MapfreCardComponent } from '../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent, AutoPaySvgGuestComponent, MapfreButtonComponent],
  selector: 'app-autopay-guest',
  templateUrl: './autopay-guest.component.html',
})
export class AutopayGuestComponent {
  policyNumber: string;

  constructor(private location: Location) {}

  goBackAPage() {
    this.location.back();
  }

}
